module.exports = __webpack_public_path__ + "static/media/basic-full-image.7aaab8e6.webp";